import { render, staticRenderFns } from "./ArchivePurchase.vue?vue&type=template&id=4b76c885&"
import script from "./ArchivePurchase.vue?vue&type=script&lang=js&"
export * from "./ArchivePurchase.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePurchase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchivePurchase.vue"
export default component.exports